module.exports = __webpack_public_path__ + "static/media/squarefour.31d9a8dd.svg";